import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { acquisition as acquisitionApi } from "@/api";
import ActaStandardPage from "@/components/layout/ActaStandardPage";

export default function AcquisitionCampaigns() {
  const [items, setItems] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    acquisitionApi.listCampaigns()
      .then((rows) => setItems(Array.isArray(rows) ? rows : []))
      .catch((err) => setError(err?.response?.data?.detail || "Impossible de charger les campagnes."));
  }, []);

  return (
    <ActaStandardPage testId="acquisition-campaigns">
      {error ? <div className="mt-4 rounded-2xl border border-[var(--do-danger-border)] bg-[var(--do-danger-soft)] p-4 text-sm text-[var(--do-danger)]">{error}</div> : null}

      <div className="mt-6 min-w-0 max-w-full overflow-hidden rounded-2xl border border-[var(--do-border)] bg-[var(--do-bg-solid)]">
        <div className="min-w-0 max-w-full overflow-x-auto overscroll-x-contain">
          <table className="w-full min-w-[760px] text-left text-sm">
            <thead className="border-b border-[var(--do-border)] text-xs uppercase tracking-wide text-[var(--do-muted)]">
              <tr>
                <th className="px-4 py-3">Campagne</th>
                <th className="px-4 py-3">Provider</th>
                <th className="px-4 py-3">Leads</th>
                <th className="px-4 py-3">Affectés</th>
                <th className="px-4 py-3">Avec affaire</th>
                <th className="px-4 py-3">Gagnés</th>
                <th className="px-4 py-3">Conversion</th>
              </tr>
            </thead>
            <tbody>
              {items.length ? items.map((item) => (
                <tr key={item.id} className="border-b border-[var(--do-border)] last:border-0">
                  <td className="px-4 py-4 font-bold text-[var(--do-ink)]"><Link className="hover:text-[var(--do-accent)]" to={`/app/acquisition/campaigns/${encodeURIComponent(item.id)}`}>{item.name}</Link></td>
                  <td className="px-4 py-4">{item.provider || "—"}</td>
                  <td className="px-4 py-4">{item.received}</td>
                  <td className="px-4 py-4">{item.assigned}</td>
                  <td className="px-4 py-4">{item.withOpportunity}</td>
                  <td className="px-4 py-4">{item.withWon}</td>
                  <td className="px-4 py-4">{item.wonRate}%</td>
                </tr>
              )) : (
                <tr><td colSpan="7" className="px-4 py-8 text-center text-[var(--do-muted)]">Aucune campagne observée.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </ActaStandardPage>
  );
}
